import React from 'react';
import moment from 'moment';
import { CiRead } from 'react-icons/ci';
import { toast } from 'react-toastify';
import {
    useGetNotificationsQuery,
    useReadNotificationClientMutation,
} from 'services/clientApi';
import './Notifications.scss';

export default function NotificationsComponent({ isMobile, mainProps, showSidebar }) {
    const { main, mainLoading, mainError } = mainProps;

    const {
        data: notifications,
        isLoading: loadingNoti,
        isError: errorNoti,
        refetch
    } = useGetNotificationsQuery();

    const [makeNotificationSeen] = useReadNotificationClientMutation();

    const makeAllNotificationSeen = () => {
        const allNotiIds = notifications?.notifications?.map(noti => noti.id) || [];

        if (allNotiIds.length > 0) {
            makeNotificationSeen({ notification_id: allNotiIds });
            refetch();
        }
        toast.success('All notification were marked as read!')
    };

    const markOneAsRead = (id) => {
        makeNotificationSeen({ notification_id: [id] });
        refetch();
        toast.success('Notification was marked as read!')
    };

    return (
        <div
            className="container-fluid bg-col transition-width"
            style={!isMobile ? {
                width: showSidebar ? 'calc(100% - 332px)' : '100%',
                marginLeft: 0,
                marginRight: 'auto',
                transition: showSidebar ? 'width 0.3s ease-in-out' : 'width 0.16s ease-in-out'
            } : {}}
        >
            <div className="row p-3 reports-panel">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-5 mt-2">MY NOTIFICATIONS</h5>
                    {notifications?.notifications?.length > 0 && (
                        <button
                            className="btn btn-sm btn-outline-primary mb-5 mt-2" 
                            onClick={makeAllNotificationSeen}
                            style={{ color: "white" }}
                        >
                            Mark all as read
                        </button>
                    )}
                </div>

                <p className="text-muted">Here you will find all the unread notifications. You can mark them as read if you want these to not show anymore.</p>

                <div className="notification-list w-100 mt-4">
                    {loadingNoti ? (
                        <p>Loading...</p>
                    ) : !notifications?.notifications?.length ? (
                        <div className="text-center text-muted my-5">No notifications to show.</div>
                    ) : (
                        notifications.notifications.map((item, index) => (
                            <div
                                className={`notification-item p-3 mb-3 border rounded-3 ${!item.seen ? 'bg-light' : ''}`}
                                key={index}
                            >
                                <div className="d-flex justify-content-between align-items-start">
                                    <div>
                                        <h6 className="fw-semibold mb-1">{item.title}</h6>
                                        <p className="text-muted mb-1">{item.description}</p>
                                        <small className="text-secondary">{moment(item.created_at).fromNow()}</small>
                                    </div>
                                    {!item.seen && (
                                        <CiRead
                                            size={20}
                                            className="text-primary"
                                            style={{ cursor: 'pointer' }}
                                            title="Mark as read"
                                            onClick={() => markOneAsRead(item.id)}
                                        />
                                    )}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div >
    );
}